import React, { Component } from "react";
import { Breadcrumb, Glyphicon, PageHeader, Grid, Row, Col, Panel, Modal, Button } from "react-bootstrap";
import ContactForm from './ContactForm';
import './Contact.css';

export default class Contact extends Component {
  constructor(props) {
  	super(props);
  	this.state = {
      show: false
  	};
  }

  handleClickMap = (evt) => {
    evt.preventDefault();
    this.setState({show: true});
  }

  handleCloseMap = () => {
    this.setState({show: false});
  }

  render() {
    return (
      <div className="Contact">
        <Grid>
        <Breadcrumb>
          <Breadcrumb.Item href="/">Inicio</Breadcrumb.Item>
            <Breadcrumb.Item active>Contacto</Breadcrumb.Item>
    	  </Breadcrumb>
  	    <PageHeader>
          Contacto
        </PageHeader>
        <Row>
          <Col md={6}>
            <Panel>
              <Panel.Heading>
                Vis&iacute;tanos
              </Panel.Heading>
              <Panel.Body>
                <Glyphicon glyph='map-marker' /> <a href="https://goo.gl/maps/KEex4x6WY1N2" target="_blank" rel="noopener noreferrer" onClick={this.handleClickMap}>Agustinas 972, oficina 1003, Santiago</a>
              </Panel.Body>
            </Panel>
            <Panel>
              <Panel.Heading>
                Ll&aacute;manos
              </Panel.Heading>
              <Panel.Body>
                <Glyphicon glyph='phone-alt' /> <a href="tel:+56222474030">+56 2 2247 4030</a>
              </Panel.Body>
            </Panel>
            <Panel>
              <Panel.Heading>
                Escr&iacute;benos
              </Panel.Heading>
              <Panel.Body>
                <Glyphicon glyph='envelope' /> <a href="mailto:contacto@portalcondominio.cl" target="_blank" rel="noopener noreferrer">contacto@portalcondominio.cl</a>
              </Panel.Body>
            </Panel>
          </Col>
          <Col md={6}>
            <ContactForm />
          </Col>
        </Row>
        <Modal show={this.state.show} onHide={this.handleCloseMap} style={{width: '630px', margin: '0 auto'}}>
          <Modal.Header>
            <Modal.Title>Nuestra ubicaci&oacute;n</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <iframe title="Mapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.3270756081974!2d-70.6525399841837!3d-33.440784204403656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c5a15bfd2deb%3A0x52b68c24cefb7e87!2sAgustinas+972%2C+Santiago%2C+Regi%C3%B3n+Metropolitana!5e0!3m2!1ses!2scl!4v1552867948031" width="600" height="450" frameBorder="0" style={{border:0}} allowFullScreen></iframe>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleCloseMap}>Cerrar</Button>
          </Modal.Footer>
        </Modal>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/contact/Contact.js